var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.84375 16.9062C0.84375 17.2865 1.20684 17.5938 1.65625 17.5938H20.3438C20.7932 17.5938 21.1562 17.2865 21.1562 16.9062V7.88281H0.84375V16.9062ZM20.3438 1.95312H16.0781V0.578125C16.0781 0.483594 15.9867 0.40625 15.875 0.40625H14.4531C14.3414 0.40625 14.25 0.483594 14.25 0.578125V1.95312H7.75V0.578125C7.75 0.483594 7.65859 0.40625 7.54688 0.40625H6.125C6.01328 0.40625 5.92188 0.483594 5.92188 0.578125V1.95312H1.65625C1.20684 1.95312 0.84375 2.26035 0.84375 2.64062V6.42188H21.1562V2.64062C21.1562 2.26035 20.7932 1.95312 20.3438 1.95312Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.854772013c8588957f5fe55bbc521459.svg";
export { ForwardRef as ReactComponent };